import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from '../';
import PropTypes from 'prop-types';

const GA_CATEGORY = 'Header Menu';

const DropdownLink = styled.a`
  color: #2f3034;
  text-decoration: none;
  line-height: 1.9;
  &:hover {
    opacity: 0.8;
  }
`;

const DropdownCol = Col.extend`
  line-height: 1.9;
`;

const DrodownRow = Col.extend`
  padding: 20px;
  paddingtop: 10;
  paddingbottom: 10;
  width: 230px;
`;

const Dropdown = ({ items = [], footer = {}, siteSource, sourceType }) => (
  <Container style={{ padding: 0 }}>
    <DrodownRow style={{ padding: 20, paddingTop: 10, paddingBottom: 10, width: 230 }}>
      {items.map(({ value, key }) => (
        <DropdownCol xs={12} key={key}>
          <DropdownLink
            href={key}
            data-ga-category={GA_CATEGORY}
            data-ga-action={`${GA_CATEGORY} - Clicked ${sourceType} ${value} - Sub Menu`}
            data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
          >
            {value}
          </DropdownLink>
        </DropdownCol>
      ))}
    </DrodownRow>
    <Row
      style={{
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
        borderTop: '1px solid #ccc',
        margin: 0
      }}
    >
      <Col xs={12} style={{ textAlign: 'center', lineHeight: 1.9 }}>
        <DropdownLink
          href={footer.key}
          data-ga-category={GA_CATEGORY}
          data-ga-action={`${GA_CATEGORY} - Clicked Browse All ${
            footer.desc
          } Categories - Sub Menu`}
          data-ga-label={`${GA_CATEGORY} - ${siteSource}`}
        >
          {footer.value}
        </DropdownLink>
      </Col>
    </Row>
  </Container>
);

Dropdown.propTypes = {
  items: PropTypes.array,
  footer: PropTypes.object,
  siteSource: PropTypes.string,
  sourceType: PropTypes.string
};

export default Dropdown;
